export default {
    Target: 1, 
    Project: 2
}